import LeftArrow from "Assets/Icons/LeftArrow";
import { Card } from "antd";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import TitleAntdComponent from "utilFunctions/shared/AntdSharedComponents/TitleAntdComponent";
export const StyledAntdCard = styled(Card)`
  .ant-card-body {
    padding: 12px;
  }
  :where(.css-dev-only-do-not-override-xlmt2j).ant-card-bordered {
    border: none !important;
  }
`;
const StyledMainDiv = styled<any>("div")`
  display: flex;
  justify-content: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "space-between" : "space-between"};
  flex-direction: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "row" : "row"};
  align-items: center !important;
  -webkit-align-items: start;
`;
const StyledCardtitleDiv = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface HeadersComponentIF {
  cardTitle: string;
  children?: any;
  backButtonHandler?: any;
  extraa?: any;
}
const HeadersComponent = ({
  cardTitle,
  children,
  backButtonHandler,
  extraa,
}: HeadersComponentIF) => {
  const { screen }: any = useWindowSize();
  return (
    <StyledAntdCard style={{ width: "100%" }}>
      <StyledMainDiv screen={screen}>
        <StyledCardtitleDiv>
          <div className="d-flex align-items-center">
            <LeftArrow
              className={"cursorHoverCSS mr-2"}
              onClick={backButtonHandler}
            />
            <TitleAntdComponent
              title={cardTitle}
              level={4}
              mbLevel={5}
            ></TitleAntdComponent>
          </div>
          <div>{extraa && extraa}</div>
        </StyledCardtitleDiv>
        <div>{children}</div>
      </StyledMainDiv>
    </StyledAntdCard>
  );
};

export default HeadersComponent;
